<div class="container-fluid">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Group Session Topics List</h2>
      </li>

      <li class="dropdown m-l-20">
        <label><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)="applyFilter($event)" aria-label="Search box">
      </li>
    </ul>

    <ul class="header-buttons mr-2" *ngIf="!isVisibilePresentational">
      <li>
        <button mat-mini-fab color="primary" (click)="addInduction()" permission="Group Session Topics" [permissionTypes]="[PermissionType.ADD, PermissionType.ALL]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
    </ul>
  </div>

<div class="row mb-3 mt-3" *ngIf="isVisibilePresentational">
  <div class="col-md-6">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Filter by Content (Multi-Select)</mat-label>
      <mat-select [(ngModel)]="selectedContents" (selectionChange)="filterByContent()" multiple>
        <mat-option (click)="toggleSelectAll($event)" [value]="'selectAll'">
          Select All Content
        </mat-option>
        <mat-divider></mat-divider>
        <mat-option *ngFor="let content of uniqueContents" [value]="content">
          {{ content }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-md-2">
    <button mat-raised-button color="warn" (click)="clearFilters()" class="w-100">
      <mat-icon>clear</mat-icon>
      Clear Filters
    </button>
  </div>
</div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">

    <ng-container matColumnDef="srNo">
      <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
      <td mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }} </td>
    </ng-container>


    <ng-container matColumnDef="content">
      <th mat-header-cell *matHeaderCellDef> Content </th>
      <td mat-cell *matCellDef="let row"> {{ row.content }} </td>
    </ng-container>

    <ng-container matColumnDef="detailedDescription" *ngIf="!isVisibilePresentational">
      <th mat-header-cell *matHeaderCellDef> Detailed Description </th>

      <td mat-cell *matCellDef="let row">
        <a
          *ngIf="row.detailedDescription"
          [href]="row.detailedDescription"
          target="_blank"
          class="text-primary"
          style="text-decoration: underline;"
        >
          {{ extractFileName(row.detailedDescription) === 'edit' ? 'View File' : extractFileName(row.detailedDescription) }}
        </a>
        <span *ngIf="!row.detailedDescription" class="text-muted">No file</span>
      </td>
    </ng-container>



    <ng-container matColumnDef="presentationUrls" *ngIf="!isVisibilePresentational">
      <th mat-header-cell *matHeaderCellDef> Presentation Links </th>

      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.presentationUrls && isArray(row.presentationUrls) && row.presentationUrls.length > 0; else noLinks">
          <div *ngFor="let url of row.presentationUrls; let idx = index" class="mb-1">
            <a
              *ngIf="url && url.startsWith('http')"
              [href]="url"
              target="_blank"
              class="d-block text-primary"
              style="text-decoration: underline;">
              {{ extractFileName(url) === 'edit' ? 'View File ' : extractFileName(url) }}
            </a>
            <span *ngIf="!url || !url.startsWith('http')" class="text-danger d-block">
              Invalid URL: {{ url }}
            </span>
          </div>
        </ng-container>
        <ng-template #noLinks>
          <span class="text-muted">No links available</span>
        </ng-template>
      </td>
    </ng-container>



    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Description </th>
      <td mat-cell *matCellDef="let row">
        {{ row.description }}
      </td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button color="accent"
                (click)="view(row)"
                permission="Group Session Topics"
                [permissionTypes]="[PermissionType.VIEW, PermissionType.ALL]">
          <mat-icon>visibility</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="edit(row)"  permission="Group Session Topics" [permissionTypes]="[PermissionType.EDIT]">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="delete(row.id)" permission="Group Session Topics" [permissionTypes]="[PermissionType.ARCHIVE]">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 25, 50,100,200]" showFirstLastButtons></mat-paginator>
</div>

